import { careerService } from './services';

export default {
  // get
  getAllJobs: (qs) => careerService().get(`/jobs${qs}`),
};
